import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import Spinner from "../../components/helpers/Spinner";
import ResponsiveModalAbsolute from "../../components/ResponsiveModalAbsolute";
import { fetchAxiosToken } from "../../helpers/fetchAxiosToken";
import { useAppSelector } from "../../hooks/hooks";
import { useDispatchDominioCorredor } from "../../hooks/useDispatchDominioCorredor";

interface Props {
    modalVisible: boolean;

    setModalVisible: (visible: boolean) => void;
}

export const ModalEditRedesSociales = ({
    modalVisible,

    setModalVisible,
}: Props) => {
    const { facebook, instagram, tiktok, id } = useAppSelector(
        (state) => state.corredor
    );
    const dispatchDominio = useDispatchDominioCorredor();
    const [saving, setSaving] = useState<boolean>(false);
    const [input, setInput] = useState({
        instagram: instagram,
        facebook: facebook,
        tiktok: tiktok,
    });

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInput({
            ...input,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async () => {
        setSaving(true);

        try {
            await fetchAxiosToken({
                url: `/corredor/updateRedesSociales/${id}`,
                method: "put",
                body: input,
            });

            setTimeout(() => {
                Swal.fire({
                    confirmButtonColor: "#029BFC",
                    iconColor: "#029BFC",
                    title: "Actualizado",
                    text: "Redes actualizadas",
                    icon: "success",
                    confirmButtonText: "Ok",
                });
                setSaving(false);

                dispatchDominio();
                setModalVisible(false);
            }, 2000);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <ResponsiveModalAbsolute
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
        >
            <div className="flex flex-col items-center justify-center max-w-lg gap-4 xl:p-4  md:p-2 p-1 mx-auto text-gray-600 ">
                <h2 className="xl:text-4xl md:text-3xl text-2xl text-[#1C4CBB] text-center font-medium">
                    Editar Redes Sociales
                </h2>
                <hr className="w-full bg-gray-300" />

                <div className="flex flex-col justify-center w-10/12">
                    <label className="ml-2 xl:text-xl md:text-lg text-base font-medium">
                        Instagram
                    </label>
                    <input
                        type={"text"}
                        min={0}
                        name="instagram"
                        value={input.instagram}
                        onChange={handleInputChange}
                        className="w-full max-w-sm xl:p-3 md:p-2.5 p-2 mx-auto mt-2 text-black border border-gray-500 rounded-lg placeholder:italic"
                    />
                </div>
                <div className="flex flex-col justify-center w-10/12">
                    <label className="ml-2 xl:text-xl md:text-lg text-base font-medium">
                        Facebook
                    </label>
                    <input
                        type={"text"}
                        min={0}
                        name="facebook"
                        value={input.facebook}
                        onChange={handleInputChange}
                        className="w-full max-w-sm xl:p-3 md:p-2.5 p-2 mx-auto mt-2 text-black border border-gray-500 rounded-lg placeholder:italic"
                    />
                </div>
                <div className="flex flex-col justify-center w-10/12">
                    <label className="ml-2 xl:text-xl md:text-lg text-base font-medium">
                        Tiktok
                    </label>
                    <input
                        type={"text"}
                        min={0}
                        step={1}
                        name="tiktok"
                        value={input.tiktok}
                        onChange={handleInputChange}
                        className="w-full max-w-sm xl:p-3 md:p-2.5 p-2 mx-auto mt-2 text-black border border-gray-500 rounded-lg placeholder:italic"
                    />
                </div>

                <div className="w-10/12 xl:mt-8 md:mt-5 mt-3 ">
                    {saving ? (
                        <Spinner />
                    ) : (
                        <button
                            onClick={() => handleSubmit()}
                            className="w-full p-3 px-5 text-white border rounded-lg bg-[#1C4CBB] hover:scale-105"
                        >
                            Guardar cambios
                        </button>
                    )}
                </div>
            </div>
        </ResponsiveModalAbsolute>
    );
};
